<template>
    <div :class="'td-banner td-banner-type-' + bannerType" v-if="bannerMessage !== null" :style="'top: ' + (extraTopMargin + 50) + 'px;'">
        <div class="container td-banner-wrap">
            <div class="col-md-12">
                <div class="td-banner-message-wrap">

                    <!-- simple text errors -->
                    <div v-if="isSimpleError()" class="td-banner-message">
                        {{$__(bannerMessage)}}

                        <ul v-if="bannerType === 'error_callback'">
                            <li v-for="(error, errorIndex) in errors">
                                <span v-html="error.message"></span>
                                <template v-if="callbackData[error.field_name] !== undefined">
                                    <!-- trash -->
                                    <a
                                        v-if="callbackData[error.field_name].type = 'trash'"
                                        href="#"
                                        :class="{'fa fa-trash-o': true, 'td-is-disabled': callbackRunning}"
                                        @click.prevent="runCallback(callbackData[error.field_name], error, errorIndex)"
                                    ></a>
                                </template>

                            </li>
                        </ul>

                        <ul v-else-if="bannerType === 'error'">
                            <li v-for="error in errors" v-html="error.message"></li>
                        </ul>

                        <!-- success banners with data fields -->
                        <div v-else-if="bannerType === 'success_with_data_fields'">
                            <br>
                            <strong>{{'Extra data: '}}</strong><hr>
                            <div style="margin: 10px auto;" v-for="field in fields" v-html="field.field_name + field.message"></div>
                        </div>

                    </div>


                    <div v-else>

                        <div class="td-complex-error-endpoint">
                            Endpoint: {{apiEndpoint}}
                        </div>


                        <!-- longer errors, most likley a data dump with stuff -->
                        <pre  class="td-banner-message-complex" v-html="getComplexMessage()">
                    </pre>
                    </div>


                </div>

                <div class="td-banner-close">
                    <span @click.prevent="clearBannerData" class="td-icon-close"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import tdApi from "../tdApi";

    window.EventBus = new Vue();

    export default {
        props: {
            extraTopMargin: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                apiEndpoint: null,
                bannerMessage: null,
                bannerType: null,
                errors: null,
                timeoutObj: null,
                showCrossRouterChange: false, // the banner will not close even if the route is changed
                fields: null, // extra data fields for success_with_data banners
                callbackData: null,
                callbackRunning: false, //wait until callback function is run
            }
        },
        created() {
            let vm = this;

            /**
             * Delete error message from list
             */
            window.EventBus.$on('deleteErrorMessage', function(errorIndex) {
                if (vm.errors !== null && Array.isArray(vm.errors) && vm.errors[errorIndex] !== undefined) {
                    vm.errors.splice(errorIndex, 1);

                    //if no error remains clear banner data
                    if (vm.errors.length === 0) {
                        vm.clearBannerData();
                    }
                }
                vm.endCallbackRunning();
            });


            /**
             * End callback running
             */
            window.EventBus.$on('endCallbackRunning', function() {
                vm.endCallbackRunning();
            });


            /**
                Green banner - that closes after 2.5 seconds
            */
            window.EventBus.$on('banner_onSuccess', function(message) {
                clearTimeout(vm.timeoutObj); // clear the previous timeout
                vm.callbackData = null;
                vm.bannerMessage = message;
                vm.bannerType = 'success';
                vm.showCrossRouterChange = false;
                vm.timeoutObj = setTimeout(function(){ vm.clearBannerData(); }, 2500);
            });


            /**
                Green banner - that does not closes itself
            */
            window.EventBus.$on('banner_onSuccessPermanent', function(message) {
                clearTimeout(vm.timeoutObj); // clear the previous timeout
                vm.callbackData = null;
                vm.bannerMessage = message;
                vm.bannerType = 'success';
                vm.showCrossRouterChange = false;
            });



            /**
                Green banner - that keeps showing up even if the route has changed.
             */
            window.EventBus.$on('banner_onSuccessCrossRouterChange', function(message) {
                clearTimeout(vm.timeoutObj); // clear the previous timeout
                vm.callbackData = null;
                vm.bannerMessage = message;
                vm.bannerType = 'success';
                vm.showCrossRouterChange = true;
                vm.timeoutObj = setTimeout(function(){ vm.clearBannerData(); }, 2500);
            });


            /**
                Red banner that closes after 3.5 seconds
             */
            window.EventBus.$on('banner_onError', function(message, errors) {
                clearTimeout(vm.timeoutObj); // clear the previous timeout
                vm.callbackData = null;
                vm.bannerMessage = message;
                vm.errors = errors;
                vm.bannerType = 'error';
                vm.showCrossRouterChange = false;
                vm.timeoutObj = setTimeout(function(){ vm.bannerMessage = null; }, 3500);
            });


            /**
                this error does not closes itself, used on connexions issues
             */
            window.EventBus.$on('banner_onErrorPermanent', function(message, errors, apiEndPoint) {
                clearTimeout(vm.timeoutObj); // clear the previous timeout
                vm.callbackData = null;
                vm.bannerMessage = message;
                vm.errors = errors;
                vm.apiEndpoint = apiEndPoint;
                vm.bannerType = 'error';
                vm.showCrossRouterChange = false;
            });

            /**
             this error does not closes itself, used on connexions issues
             */
            window.EventBus.$on('banner_onErrorPermanentCallback', function(message, errors, apiEndPoint, callbackData) {
                clearTimeout(this.timeoutObj); // clear the previous timeout
                vm.callbackData = callbackData;
                vm.bannerType = 'error_callback';
                vm.bannerMessage = message;
                vm.errors = errors;
                vm.apiEndpoint = apiEndPoint;
                vm.showCrossRouterChange = false;
            });


            /**
                success with data fields message for debugging
             */
            window.EventBus.$on('banner_onSuccessPermanentWithDataFields', function(message, fields) {
                clearTimeout(this.timeoutObj); // clear the previous timeout
                vm.callbackData = null;
                vm.bannerMessage = message;
                vm.fields = fields;
                vm.bannerType = 'success_with_data_fields';
            });


            /**
                hides any errors
             */
            window.EventBus.$on('banner_reset', function() {
                vm.clearBannerData();
            });

        },

        methods: {
            endCallbackRunning() {
                this.callbackRunning = false;
            },

            runCallback(callbackData, error, errorIndex) {
                let vm = this,
                    params = [];

                if (vm.callbackRunning === true) {
                    return;
                }

                vm.callbackRunning = true;

                callbackData.return_params.forEach(function(paramName) {
                    if (error[paramName] !== undefined) {
                        params.push(error[paramName]);
                    }
                });

                params.push(errorIndex);

                callbackData.callback(...params);
            },

            clearBannerData() {
                clearTimeout(this.timeoutObj); // clear the previous timeout
                this.callbackData = null;
                this.bannerMessage = null;
                this.bannerType = null;
                this.bannerType = null;
            },


            // show complex banner only on errors that are larger :)) most likely a dump
            // it ignores the vm.errors numbers
            isSimpleError() {
                if (this.bannerType !== 'error') {
                    return true;
                }
                if (this.bannerMessage.length > 200) {
                    return false;
                }
                return true;
            },


            /**
             * fix new lines, tabs etc... in errors so we can get a pretty error
             * @returns {*}
             */
            getComplexMessage() {
                let fixMessage = this.bannerMessage.replace(/\\r\\n/g, "\n");
                fixMessage = fixMessage.replace(/\\t/g, '    ');
                console.log(fixMessage);
                return fixMessage;
            }


        },

        watch: {
            '$route' (to, from) {
                if (this.showCrossRouterChange !== true) {
                    // react to route changes...
                    this.clearBannerData();
                }

            }
        }
    }
</script>

<style lang="scss">
    .td-banner {
        background-color: #44d074;
        padding: 10px 0;
        position: fixed;
        z-index: 1030;
        width: 100%;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

        @media print {
            display: none !important;
        }

        .td-banner-wrap {
            position: relative;
        }

        .td-banner-message-wrap {
            padding-right: 30px;

            ul {
                margin: 10px 0 0 0;
                padding: 0 0 0 15px;
            }

            li {
                font-size: 12px;
                line-height: 1.8;
                color: #fff;
            }

            .td-is-disabled {
                pointer-events: none;
                opacity: 0.6;
            }
        }

        .td-banner-message-complex {
            font-weight: 600;
            color: #fff;
            background-color: transparent;
            max-height: 700px;
            a {
                color: white;
                text-decoration: underline;
            }
        }

        .td-banner-message {
            font-weight: 600;
            color: #fff;

            a {
                color: #fff;
                text-decoration: underline;
            }

            b {
                background-color: black;
                display: inline-block;
                padding: 4px 10px;
                margin-left: 5px;
                font-weight: normal;
                border-radius: 3px;
            }
        }

        .td-banner-close {
            text-align: right;
            position: absolute;
            right: 15px;
            top: -1px;

            span {
                font-size: 10px;
                line-height: 20px;
                width: 20px;
                height: 20px;
                color: rgba(0, 0, 0, 0.3);
                background-color: rgba(255,255,255,0.25);
                border-radius: 50%;
                cursor: pointer;
                transition: background-color 0.2s ease;

                &:hover,
                &:active,
                &:focus {
                    background-color: rgba(255,255,255,0.4);
                }
            }
        }

        &.td-banner-type-error,
        &.td-banner-type-error_callback,{
            background-color: #ec4848;
        }


        .td-complex-error-endpoint {
            color:white;
            font-weight: bold;
            margin: 5px 0 10px 0;
        }

		.td-icon-close:before { content: "\e83c";}

    }


</style>



// WEBPACK FOOTER //
// src/components/messageBanner.vue